import { METHOD_CHECK_QUEST, } from "./defs";
var WorkerPromise = /** @class */ (function () {
    function WorkerPromise(workerUrl) {
        var _this = this;
        this.workerUrl = workerUrl;
        this.worker = new Worker(this.workerUrl);
        this.id = 0;
        this.waiters = new Map();
        this.worker.addEventListener("error", function (e) {
            var msg = e.message + " at " + e.lineno + ":" + e.colno;
            var err = new Error(msg);
            _this.waiters.forEach(function (_a) {
                var reject = _a.reject;
                return reject(err);
            });
            _this.waiters.clear();
        });
        this.worker.addEventListener("message", function (e) {
            var result = JSON.parse(e.data);
            var waiter = _this.waiters.get(result.id);
            _this.waiters.delete(result.id);
            if (waiter) {
                if (!result.errorMessage) {
                    waiter.resolve(result.data);
                }
                else {
                    waiter.reject(new Error(result.errorMessage));
                }
            }
            else {
                console.warn("Unknown message from webworker", e.data);
            }
        });
    }
    WorkerPromise.prototype.destroy = function () {
        this.worker.terminate();
    };
    WorkerPromise.prototype.call = function (methodName, data) {
        var _this = this;
        // tslint:disable-next-line:promise-must-complete
        return new Promise(function (resolve, reject) {
            _this.id++;
            _this.waiters.set(_this.id, { resolve: resolve, reject: reject });
            var raw = {
                id: _this.id,
                method: methodName,
                data: data,
            };
            _this.worker.postMessage(JSON.stringify(raw));
        });
    };
    WorkerPromise.prototype.checkQuest = function (data) {
        return this.call(METHOD_CHECK_QUEST, data);
    };
    return WorkerPromise;
}());
export { WorkerPromise };
//# sourceMappingURL=data:application/json;base64,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